import { FC, ReactNode } from 'react';
import { getBugsnagErrorBoundary } from '@cfacorp/ctrl-platform-ui-core-utils';

interface ErrorBoundaryProps {
  children: ReactNode;
}

const ErrorBoundary: FC<ErrorBoundaryProps> = ({ children }) => {
  const AppBugsnagErrorBoundary = getBugsnagErrorBoundary();
  if (AppBugsnagErrorBoundary) {
    return (
      <AppBugsnagErrorBoundary
        onError={event => (event.unhandled = true)}
        FallbackComponent={() => (
          <div>
            {/* eslint-disable-next-line i18next/no-literal-string */}
            <h1>Error boundary from Bugsnag</h1>
          </div>
        )}
      >
        <>{children}</>
      </AppBugsnagErrorBoundary>
    );
  }
  return <>{children}</>;
};

export default ErrorBoundary;
